export default __webpack_public_path__ + "static/media/1086.6be8aff3.png";